module.exports = __webpack_public_path__ + "img/business-blueprint.92cf0575.png";